import { Backdrop, Box } from '@mui/material';
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useDebounce } from '@uidotdev/usehooks'
import Spinner from 'components/Spinner';
import DialogProvider from 'common/DialogProvider';
import { ToastMessageProvider } from 'components/ToastMessages/ToastMessageProvider';

export const LayoutContext = createContext({
    loading: false,
    setLoading: (loading: boolean) => { },
    setLayoutLoadingMode: (mode: "layout" | "full-screen") => { }
});

const DELAY = 1000;

export default function LayoutProvider({ children }: { children: React.ReactNode }) {
    const [loading, setLoading] = useState(true);
    const [showLoading, setShowLoading] = useState(true);
    const debouncedLoading = useDebounce(loading, DELAY);
    const [layoutLoadingMode, setLayoutLoadingMode] = useState<"layout" | "full-screen">("full-screen");
    useEffect(() => {
        if(loading){
            setShowLoading(true);
        }else{
            if(!debouncedLoading){
                setShowLoading(false);
            }
        }
    }, [loading, debouncedLoading]);

    return (
        <LayoutContext.Provider value={{
            loading: showLoading,
            setLoading: setLoading,
            setLayoutLoadingMode: setLayoutLoadingMode
        }}>
            <DialogProvider>
                <ToastMessageProvider>
                    <Backdrop
                        sx={(theme) => ({ zIndex: theme.zIndex.drawer + 99 })}
                        open={showLoading && layoutLoadingMode === "full-screen"}
                    >
                        <Box className="loading-background">
                            <Box className="loading-bar" >                           
                                <Spinner small />
                            </Box>
                        </Box>
                    </Backdrop>
                    {children}
                </ToastMessageProvider>
            </DialogProvider>
        </LayoutContext.Provider>
    );
}

export function useLayout() {
  return useContext(LayoutContext);
}